export default __webpack_public_path__ + "svgs/trustpilotStarEmpty-808f6e3f.svg";